// extracted by mini-css-extract-plugin
export default {"clientsFiltersContainer":"clientsFilters_clientsFiltersContainer__b606m","collapsableComponent":"clientsFilters_collapsableComponent__0x3rR"};